export const width = 417;
export const height = 311;
export default __webpack_public_path__ + "static/5.5cb82070.svg";